import { render, staticRenderFns } from "./OrderSourceLogo.vue?vue&type=template&id=1e2e42c2&"
import script from "./OrderSourceLogo.vue?vue&type=script&lang=ts&"
export * from "./OrderSourceLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports